<template>
  <div>
    <div class="landingpage-top-line d-md-none pt-4">
      <div class="line-1 mb-3"></div>
      <div class="line-2"></div>
    </div>

    <section class="container-fluid d-flex justify-content-between">
      <div class="landingpage-left-line d-none d-md-block">
        <img src="@/assets/img/left.png" class="img-fluid" alt="" />
      </div>

      <div
        class="d-flex align-items-center justify-content-center min-vh-100 my-0"
      >
        <div
          class="px-0 px-md-3 col-md-12 text-center my-5 py-4 my-md-0 py-md-0"
        >
          <!-- <img
            src="@/assets/img/svg/EmpirePremierLogo1.svg"
            class="img-fluid main-logo2"
          /> -->

          <!-- Using slots -->
          <!-- <b-input-group class="col-lg-4 col-xl-3 mt-5 mx-auto">
          <b-form-input />
          <b-input-group-text class="pr-0" slot="append">
            <router-link to="#"> AUTO DETECT</router-link>
            <span v-if="preimere == true || preimere == 'true'" class="ml-1"><img src="@/assets/img/svg/location-pin-black.svg" height="13" width="13"
                style="margin-top:6px;"></span>
                <span v-else class="ml-1"><img src="@/assets/img/svg/location-pin.svg" height="13" width="13"
                style="margin-top:6px;"></span>
          </b-input-group-text>
        </b-input-group>-->

          <!-- NEW UI { -->

          <img src="@/assets/img/new-logo.png" class="img-fluid main-logo2" />
          <div class="my-5">
            <h4 class="mb-3 d-md-none">CHOOSE YOUR COUNTRY</h4>
            <h5 class="mb-3 d-none d-md-block">CHOOSE YOUR COUNTRY</h5>
            <h6 class="d-none d-md-block">
              PLEASE SELECT YOUR PREFERRED COUNTRY BELOW:
            </h6>
            <p class="d-md-none">PLEASE SELECT YOUR PREFERRED COUNTRY BELOW:</p>

            <div
              class="my-4 px-0 px-md-3 col-12 col-md-12 mx-auto d-flex justify-content-center"
            >
              <ul class="list-inline country-selection-list mb-0">
                <li
                  class="
                    list-inline-item
                    mb-4 mb-md-3
                    d-block
                    col-12
                  "
                >
                  <a href="https://ksa.empirecinemas.com/">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div class="mr-2 d-none d-md-block">
                        <!-- <img
                          src="@/assets/img/SaudiArabiaFlag.png"
                          alt=""
                          class="flag_custom"
                        /> -->
                        <img
                          src="@/assets/img/ksa.png"
                          alt=""
                          class="flag_custom"
                        />
                      </div>

                      <div class="d-flex align-items-center w-100">
                        <div class="no-hover-effect d-md-none flex-2">
                          <!-- <img
                            src="@/assets/img/SaudiArabiaFlag.png"
                            class="flag_custom"
                            alt=""
                          /> -->
                          <img
                            src="@/assets/img/ksa.png"
                            class="flag_custom"
                            alt=""
                          />
                        </div>
                        <div class="Item flex-1 custom-margin">
                          Saudi Arabia
                        </div>
                        <div class="mx-2 no-hover-effect d-none d-md-block">
                          /
                        </div>

                        <div class="Item flex-3">
                          المملكة العربية السعودية
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <!-- <li
                class="list-inline-item mb-4 mb-md-3"
                @click="onSelectCountry('Saudi Arabia', 230, 'ar', 1)"
              >
                <div class="d-flex align-items-center">
                  <div class="mr-2">
                    <img src="@/assets/img/SaudiArabiaFlag.png" alt="" />
                  </div>

                </div>
              </li> -->

                <li
                  class="
                    list-inline-item
                    mb-4 mb-md-3
                    d-block 
                    col-12
                  "
                >
                  <a href="https://lb.empirecinemas.com/">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div class="mr-2 d-none d-md-block">
                        <!-- <img
                          src="@/assets/img/LebanonFlag.png"
                          alt=""
                          class="flag_custom"
                        /> -->
                        <img
                          src="@/assets/img/lb.png"
                          alt=""
                          class="flag_custom"
                        />
                      </div>
                      <div class="d-flex align-items-center w-100">
                        <div class="no-hover-effect d-md-none flex-2">
                          <!-- <img
                            src="@/assets/img/LebanonFlag.png"
                            class="flag_custom"
                            alt=""
                          /> -->
                          <img
                            src="@/assets/img/lb.png"
                            class="flag_custom"
                            alt=""
                          />
                        </div>
                        <div class="Item flex-1 custom-margin">
                          Lebanon
                        </div>
                        <div class="mx-2 no-hover-effect d-none d-md-block">
                          /
                        </div>

                        <div class="Item flex-3">
                          لبنان
                        </div>
                      </div>
                    </div>
                  </a>
                </li>

                <li
                  class="
                    list-inline-item
                    mb-4 mb-md-3
                    d-block
                    col-12
                  "
                >
                  <a href="https://irq.empirecinemas.com/">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div class="mr-2 d-none d-md-block">
                        <!-- <img
                          src="@/assets/img/IraqFlag.png"
                          alt=""
                          class="flag_custom"
                        /> -->
                        <img
                          src="@/assets/img/irq.png"
                          alt=""
                          class="flag_custom"
                        />
                      </div>
                      <div class="d-flex align-items-center w-100">
                        <div class="no-hover-effect d-md-none flex-2">
                          <!-- <img
                            src="@/assets/img/IraqFlag.png"
                            class="flag_custom"
                            alt=""
                          /> -->
                          <img
                            src="@/assets/img/irq.png"
                            class="flag_custom"
                            alt=""
                          />
                        </div>
                        <div class="Item flex-1 custom-margin">
                          Iraq
                        </div>

                        <div class="mx-2 no-hover-effect d-none d-md-block">
                          /
                        </div>

                        <div class="Item flex-3">
                          ٱلْعِرَاق
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <!-- <li
                class="list-inline-item mb-4 mb-md-3"
                @click="onSelectCountry('Iraq', 102, 'ar', 1)"
              >
                <div class="d-flex align-items-center">
                  <div class="mr-2">
                    <img src="@/assets/img/IraqFlag.png" alt="" />
                  </div>
                  <div>ٱلْعِرَاق‎</div>
                </div>
              </li> -->

                <!-- <li
                class="list-inline-item mb-4 mb-md-3"
                @click="onSelectCountry('Lebanon', 119, 'ar', 1)"
              >
                <div class="d-flex align-items-center">
                  <div class="mr-2">
                    <img src="@/assets/img/LebanonFlag.png" alt="" />
                  </div>
                  <div>لبنان</div>
                </div>
              </li> -->
              </ul>
            </div>

            <div class="col-12 col-md-12 mx-auto landingpage-text">
              On your next visit, through the use of cookies, you will be
              automatically directed to your preferred countries website. <br />
              By continuing to the Empire Cinemas website, you will be agreeing
              to the
              <a
                href="https://ksa.empirecinemas.com/ksa-terms-condition"
                style="color:#ce1f2e;"
                >terms and conditions</a
              >, privacy policy and terms of use.
            </div>
          </div>

          <!-- NEW UI } -->

          <!-- <div v-if="langName == 'ar'" class="landing-text mt-4 small">يرجى ملاحظة أنك قد تواجه
         انقطاعًا في الخدمة ، فنحن نقوم بتحديث موقعنا وتطبيقات الجوال لتحسين تجربة المستخدم ، نعتذر عن أي إزعاج.</div>
       <div v-else class="landing-text mt-4 small">
          Kindly note that you might experience service interruptions, we are upgrading our Website and Mobile Apps
          to enhance user experience, we apologize for any inconvenience.</div>
        </div>-->
        </div>
        <b-modal
          no-close-on-esc
          no-close-on-backdrop
          id="NoHostDataModal"
          ref="NoHostDataModal"
          title="Redirect"
          class="ErModal light-red-color"
        >
          <!-- <img class="mx-auto d-block mt-4" src="@/assets/img/svg/alert-icon.svg" width="45" height="auto"> -->
          <h6 class="pt-3 mb-0 text-center font-weight-bold">
            <!-- {{ allLanguageData.RedirectText }} {{ RedirectURL }} -->
          </h6>
          <b-button
            @click="onClickOk()"
            variant="default"
            class="btn btn-green mt-4 mb-3"
          >
            <!-- {{ allLanguageData.ErrorModal.Btn }} -->
          </b-button>
        </b-modal>
      </div>

      <div class="landingpage-right-line d-none d-md-block">
        <img src="@/assets/img/right.png" class="img-fluid" alt="" />
      </div>
    </section>

    <div class="landingpage-bottom-line d-md-none pb-4">
      <div class="line-1 mb-3"></div>
      <div class="line-2"></div>
    </div>
  </div>
</template>

<script>
// import { defineComponent } from "@vue/composition-api";

export default {
  name: "LandingPage",
  data() {
    return {
      smCardView: true,
    };
  },
};
</script>
<style scoped>
.custom-img-fluid {
  width: 20%;
}
.flag_custom {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  image-rendering: pixelated;
  object-position: center;
  object-fit: cover;
}
.list-inline-item a {
  color: #000;
}

@media screen and (max-width: 768px) {
  .flag_custom {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .custom-margin {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/StaticLandingPage.vue